import __var_0__ from './main.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Compute the exponential function of a complex number.
*
* @module @stdlib/math/base/complex/exp
*
* @example
* var cexp = require( '@stdlib/math/base/complex/exp' );
*
* var v = cexp( 0.0, 0.0 );
* // returns [ 1.0, 0.0 ]
*
* @example
* var cexp = require( '@stdlib/math/base/complex/exp' );
*
* var out = [ 0.0, 0.0 ];
*
* var v = cexp( out, 0.0, 1.0 );
* // returns [ ~0.540, ~0.841 ]
*
* var bool = ( v === out );
* // returns true
*/

// MODULES //
var cexp = __var_0__;


// EXPORTS //
export default cexp;
